import * as React from 'react';

export const LittleTop3Icon = (isHovered: boolean, props?: React.HTMLAttributes<SVGElement>) => (
  // eslint-disable-next-line react/forbid-elements
  <svg {...props} height="15" viewBox="0 0 15 15" width="15" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fillRule="evenodd">
      <circle cx="7.5" cy="7.5" fill={isHovered ? '#CC6E09' : '#FF8400'} r="7" />
      <path d="M11.5 9l-4-6.1-4 6.1H6v3h3V9z" fill="#FFF" />
    </g>
  </svg>
);
